import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-22b6b164"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "状态：", -1));
const _hoisted_3 = {
  key: 7,
  style: {
    "color": "#f24014"
  }
};
const _hoisted_4 = ["title"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_t_icon = _resolveComponent("t-icon");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _ctx.comData.types == 3 ? (_openBlock(), _createBlock(_component_t_icon, {
    key: 0,
    name: "check-circle",
    class: "statecard-icon",
    style: {
      "color": "#00be63"
    }
  })) : _createCommentVNode("", true), _ctx.comData.types == 6 || _ctx.comData.types == 7 ? (_openBlock(), _createBlock(_component_t_icon, {
    key: 1,
    name: "error-circle",
    class: "statecard-icon",
    style: {
      "color": "#f24014"
    }
  })) : _createCommentVNode("", true), _ctx.comData.types == 5 ? (_openBlock(), _createBlock(_component_t_icon, {
    key: 2,
    name: "error-circle",
    class: "statecard-icon",
    style: {
      "color": "#000000"
    }
  })) : _createCommentVNode("", true), _ctx.comData.types == 4 ? (_openBlock(), _createBlock(_component_t_icon, {
    key: 3,
    name: "chevron-down-circle",
    class: "statecard-icon",
    style: {
      "transform": "rotate(45deg)",
      "color": "#f24014"
    }
  })) : _createCommentVNode("", true), _ctx.comData.types == 2 || _ctx.comData.types == 8 ? (_openBlock(), _createBlock(_component_t_icon, {
    key: 4,
    name: "chevron-down-circle",
    class: "statecard-icon",
    style: {
      "transform": "rotate(45deg)",
      "color": "#0029ff"
    }
  })) : _createCommentVNode("", true), _ctx.comData.types == 1 && !_ctx.lastFlag ? (_openBlock(), _createBlock(_component_t_icon, {
    key: 5,
    name: "chevron-down-circle",
    class: "statecard-icon",
    style: {
      "transform": "rotate(45deg)",
      "color": "#0029ff"
    }
  })) : _createCommentVNode("", true), _ctx.comData.types == 1 && _ctx.lastFlag ? (_openBlock(), _createBlock(_component_t_icon, {
    key: 6,
    name: "chevron-down-circle",
    class: "statecard-icon",
    style: {
      "transform": "rotate(45deg)",
      "color": "#f24014"
    }
  })) : _createCommentVNode("", true), _ctx.lastFlag ? (_openBlock(), _createElementBlock("span", _hoisted_3, " 未提交内容, 将于" + _toDisplayString(_ctx.lastDays) + "天后删除 ", 1)) : _createCommentVNode("", true), !_ctx.lastFlag ? (_openBlock(), _createElementBlock("div", {
    key: 8,
    class: "statecard-version",
    style: _normalizeStyle({
      color: _ctx.typeColor[_ctx.comData.types]
    }),
    title: _ctx.comData.versions
  }, " v" + _toDisplayString(_ctx.comData.versions), 13, _hoisted_4)) : _createCommentVNode("", true), !_ctx.lastFlag ? (_openBlock(), _createElementBlock("div", {
    key: 9,
    style: _normalizeStyle({
      color: _ctx.typeColor[_ctx.comData.types],
      padding: '0px 3px'
    })
  }, _toDisplayString(_ctx.typemap[_ctx.comData.types]), 5)) : _createCommentVNode("", true)]);
}